@if (commandList?.length > 0) {
  <div class="command-list"
    >
    @for (command of commandList; track command) {
      <div>
        <div class="command-list-row"
          matRipple>
          <app-command-list-item [order]="command"
          (click)="commandOnClick(command)"></app-command-list-item>
        </div>
        <mat-divider class="command-row-divider"></mat-divider>
      </div>
    }
    @if (isLoading) {
      <app-command-list-template></app-command-list-template>
    }
    @if (displayMoreOrder) {
      <div
        class="command-list-more">
        <button class="command-list-more-button full-width"
          mat-flat-button
          color="accent"
          (click)="moreOrdersOnClick()">
          {{ 'COMMAND.GET_MORE' | transloco }}
        </button>
      </div>
    }
  </div>
} @else {
  @if (!isLoading) {
    <div
      class="commands-empty flex-column justify-center align-center">
      <div class="commands-title">
        {{ 'COMMAND.NO_COMMANDS' | transloco }}
      </div>
      @if ((isEmbedded === false)) {
        <div>
          <button class="full-width"
            mat-flat-button
            color="primary"
            (click)="onCreateOrderClick()">
            {{ 'COMMAND.CREATE' | transloco }}
          </button>
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <app-command-list-template></app-command-list-template>
  }
}

